import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from './../services/user.service';
import { EncrDecrService } from './../services/encr-decr.service';


@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  
  user_id: any='';
  company_id: any='';
  APIKEY:any= '';
  model: any = { 
    password:'',
  };

  loaderMode=false;
   
  constructor(private _user:UserService,
    private _router : Router,
    private toastr: ToastrService,
    private EncrDecr: EncrDecrService,) { }

  ngOnInit() {
    this.user_id =localStorage.getItem('id'),
    this.company_id =localStorage.getItem('company_id');
    this.APIKEY =localStorage.getItem('APIKEY');
 

  }


  
  onFormSubmit(){
    this.model["APIKEY"] ='SOAV2@123';
    var password='';
 this._user.getpassword(this.model)
      .subscribe(
        res => { 
          // this.loaderMode=false;
          if(res.data!='not_found'){
           
            password = this.EncrDecr.get(localStorage.getItem('key'), res.data);
         this.forget_password(password);
          }
       
        },
      ); 
      


  }
  
  forget_password(customer_id){
    this.loaderMode=true;
    this.model.password=customer_id;
    this.model["APIKEY"] ='SOAV2@123';
      // get auto conatct number 
      this._user.forgotPassword(this.model)
      .subscribe(
        res => { 
           this.loaderMode=false;
          
           alert(res.message);
          /// this.model={};
          //this.model["customer_no"] =res.data;
        },
      ); 

  }
}
